import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { productsByCategory, directCategories } from '../data/productsData';
import ProductListing from './ProductListing';

export default function Products() {
  const { category } = useParams();

  // If no category → show all non-uniform/belt products
  if (!category) {
    return <Navigate to="/products/mma-shorts" replace />;
  }

  const catMeta = directCategories[category];
  const products = productsByCategory[category];

  if (!catMeta || !products) return <Navigate to="/" replace />;

  return <ProductListing catMeta={catMeta} products={products} backPath={null} backLabel={null} />;
}